/**
 * Conditional class names. Six lines instead of `clsx`, because that is all the project
 * uses of it — and a dependency in the reader-facing bundle has to earn its bytes
 * (phases.md Phase 17's budget is enforced from Phase 0).
 */
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter((value): value is string | number => Boolean(value)).join(' ');
}
